import { render, staticRenderFns } from "./Animation2.vue?vue&type=template&id=0b151265&scoped=true"
var script = {}
import style0 from "./Animation2.vue?vue&type=style&index=0&id=0b151265&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b151265",
  null
  
)

export default component.exports